import Circles from 'circles'

export default class DashboardCircle {
  constructor(el, total) {
    this.$ = $(el);
    this.circle = Circles.create({
      id: this.$.attr("id"),
      radius: 75,
      value: this.count(),
      maxValue: total,
      width: 6,
      text: ((function(_this) {
        return function() {
          return _this.html();
        };
      })(this)),
      colors: ["#CCCCCC", this.color()],
      duration: 400
    });
  }

  resize() {
    return this.circle.updateRadius(this.$.width() / 2);
  }

  count() {
    return this.$.data("count");
  }

  color() {
    return this.$.data("color");
  }

  label() {
    return this.$.data("label");
  }

  html() {
    return "<span class=\"circle-count\" style=\"color:" + (this.color()) + ";\">" + (this.count()) + "</span>\n<span class=\"circle-label\" style=\"color:" + (this.color()) + ";\">" + (this.label()) + "</span>";
  }
}
